import api from "../../api/axiosInstance";
import { adalConfig } from "../../common/endpoints";

// API function to fetch live offers
export const getLiveOffersList = async (VorgMpnId:string) => {
  try {
    const response = await api.get(
       adalConfig?.endpoints?.getLiveOffers + `?vOrgMPNId=${VorgMpnId}`
    );
    return response?.data?.OfferDetails;
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || "Something went wrong");
  }
};
